
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-subscription",
      function () {
        return require("private-next-pages/news-subscription.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-subscription"])
      });
    }
  